import { Outlet } from "react-router-dom";
import Sidebar from "../components/globals/Sidebar";
import { contributerSidebarLinks } from "../sidebarLinks";
import { Button } from "reactstrap";
import SidebarToggler from "../components/globals/SidebarToggler";
import { createContext, useEffect, useState } from "react";
import { FullScreenView } from "../components/specials/FullScreenView";



const ContributerLayout = ({ onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const listener=()=>{
    onLogout();
  }


useEffect(()=>{
window.addEventListener("user-logout",listener)
  return ()=>window.removeEventListener("user-logout",listener);
},[])
     


  return (
    <div className="full-screen d-flex overflow-hidden">
      <Sidebar
        isOpen={sidebarOpen}
        onLogoutClick={onLogout}
        setIsOpen={setSidebarOpen}
        links={contributerSidebarLinks}
      />
   
        <div className="main-screen">
          <SidebarToggler
            iconColor={"black"}
            isOpen={sidebarOpen}
            responsiveClassName={"sidebar-toggler"}
            setisOpen={setSidebarOpen}
          />
          <FullScreenView />
          <Outlet />
        </div>
    
    </div>
  );
};

export default ContributerLayout;
